export const REDUCER_NAME="customerSlice";
export interface iCustomerDTO {
    gstNumber: null;
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    mobile?: string;
    state?: string;
    city?: string;
    zip?: string;
    address?: string;
}

export interface iCustomerResponse {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    state: string;
    city: string;
    zip: string;
    address: string;
    createdAt: string;
}

export interface iCustomerState {
    customerList: iCustomerDTO[] | null;
    customerDetails: iCustomerResponse | null;
    isLoading: boolean;
    errorMessage: string | null;
    pagination: {
      page: number;
      limit: number;
      totalPages: number;
      totalCount: number;
    } | null;
}
